export default function Footer() {
  return (
    <footer className="theme-footer h-10 flex items-center justify-center px-6 border-t" style={{ borderColor: 'var(--nad-b1)' }}>
      <p
        className="text-[11px] font-medium tracking-wide"
        style={{ color: 'var(--nad-accent-soft)' }}
      >
        Copyright ©iSource Asia Business Solutions Corporation. All rights reserved.
      </p>
    </footer>
  );
}
